module.exports = "<div ng-repeat=\"item in $ctrl.items\"><li ng-if=item.url_destino><a ng-href={{item.url_destino}}>{{item.nombre}}</a><li ng-if=\"!item.url_destino && !item.hijas.length\"><a ui-sref=home.categorySlugProducts({categorySlug:item.slug})>{{item.nombre}}</a><li class=dropdown ng-if=\"!item.url_destino && item.hijas.length\"><a ui-sref=home.categorySlug({categorySlug:item.slug})>{{item.nombre}}</a><ul class=\"dropdown list-unstyled\"></ul><div menu=item.hijas></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/home/categories-menu/templates/categories-menu-base.view.html
 ** module id = 714
 ** module chunks = 7
 **/